import {
  Activity,
  Heart,
  Sunrise,
  type LucideIcon,
  Apple,
  Sprout,
  Zap,
  Moon,
  ChefHat,
  GlassWater,
  Leaf,
  Smile,
  Salad,
  Timer,
  Utensils,
  Clock,
  FlameKindling,
} from "lucide-react";

interface GoalItem {
  id: string;
  textKey: string;
  icon: LucideIcon;
  color: string;
}

export const goals: GoalItem[] = [
  {
    id: "1",
    textKey: "goals.1",
    icon: Activity,
    color:
      "bg-orange-50 dark:bg-orange-950 text-orange-600 dark:text-orange-400 border-orange-100 dark:border-orange-900",
  },
  {
    id: "2",
    textKey: "goals.2",
    icon: Salad,
    color:
      "bg-purple-50 dark:bg-purple-950 text-purple-600 dark:text-purple-400 border-purple-100 dark:border-purple-900",
  },
  {
    id: "3",
    textKey: "goals.3",
    icon: Moon,
    color:
      "bg-blue-50 dark:bg-blue-950 text-blue-600 dark:text-blue-400 border-blue-100 dark:border-blue-900",
  },
  {
    id: "4",
    textKey: "goals.4",
    icon: Sunrise,
    color:
      "bg-yellow-50 dark:bg-yellow-950 text-yellow-600 dark:text-yellow-400 border-yellow-100 dark:border-yellow-900",
  },
  {
    id: "5",
    textKey: "goals.5",
    icon: Zap,
    color:
      "bg-green-50 dark:bg-green-950 text-green-600 dark:text-green-400 border-green-100 dark:border-green-900",
  },
  {
    id: "6",
    textKey: "goals.6",
    icon: Sprout,
    color:
      "bg-rose-50 dark:bg-rose-950 text-rose-600 dark:text-rose-400 border-rose-100 dark:border-rose-900",
  },
  {
    id: "7",
    textKey: "goals.7",
    icon: Apple,
    color:
      "bg-indigo-50 dark:bg-indigo-950 text-indigo-600 dark:text-indigo-400 border-indigo-100 dark:border-indigo-900",
  },
  {
    id: "8",
    textKey: "goals.8",
    icon: GlassWater,
    color:
      "bg-fuchsia-50 dark:bg-fuchsia-950 text-fuchsia-600 dark:text-fuchsia-400 border-fuchsia-100 dark:border-fuchsia-900",
  },
  {
    id: "9",
    textKey: "goals.9",
    icon: Leaf,
    color:
      "bg-emerald-50 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-900",
  },
  {
    id: "10",
    textKey: "goals.10",
    icon: Smile,
    color:
      "bg-cyan-50 dark:bg-cyan-950 text-cyan-600 dark:text-cyan-400 border-cyan-100 dark:border-cyan-900",
  },
  {
    id: "11",
    textKey: "goals.11",
    icon: Utensils,
    color:
      "bg-pink-50 dark:bg-pink-950 text-pink-600 dark:text-pink-400 border-pink-100 dark:border-pink-900",
  },
  {
    id: "12",
    textKey: "goals.12",
    icon: Timer,
    color:
      "bg-violet-50 dark:bg-violet-950 text-violet-600 dark:text-violet-400 border-violet-100 dark:border-violet-900",
  },
  {
    id: "13",
    textKey: "goals.13",
    icon: ChefHat,
    color:
      "bg-teal-50 dark:bg-teal-950 text-teal-600 dark:text-teal-400 border-teal-100 dark:border-teal-900",
  },
  {
    id: "14",
    textKey: "goals.14",
    icon: Clock,
    color:
      "bg-amber-50 dark:bg-amber-950 text-amber-600 dark:text-amber-400 border-amber-100 dark:border-amber-900",
  },
  {
    id: "15",
    textKey: "goals.15",
    icon: Heart,
    color:
      "bg-lime-50 dark:bg-lime-950 text-lime-600 dark:text-lime-400 border-lime-100 dark:border-lime-900",
  },
  {
    id: "16",
    textKey: "goals.16",
    icon: FlameKindling,
    color:
      "bg-red-50 dark:bg-red-950 text-red-600 dark:text-red-400 border-red-100 dark:border-red-900",
  },
];

export const onBoardingGoals: GoalItem[] = [
  goals[5],
  goals[6],
  goals[7],
  goals[8],
  goals[9],
  goals[14],
];
